export default "__VITE_ASSET__CtScp9FE__"